<template>
	<div class="wrap">
		<!-- CY: 열람범위 밖 고객(본부·다른 담당자)은 서버가 카드 API 를 403 으로 막는다(denied='scope'). 그 밖의 실패
		     (일시 오류·삭제된 고객)는 같은 자리에 다시 시도를 둔다. 목록에서 연 창이면 어느 쪽이든 이전·다음으로 넘어간다. -->
		<div class="content" v-if="denied">
			<div class="section">
				<p class="ud-denied" v-if="denied === 'scope'">이 고객카드를 열 수 없습니다. 일반 직원은 본인 담당 고객, 팀장은 팀 고객까지 볼 수 있습니다.</p>
				<p class="ud-denied" v-else>고객카드를 불러오지 못했습니다.</p>
				<div class="ud-denied-actions">
					<button v-if="hasNav" type="button" class="btn btn-sm btn-secondary" @click="getTotal('prev')">이전 고객</button>
					<button v-if="denied !== 'scope'" type="button" class="btn btn-sm btn-primary" @click="init()">다시 시도</button>
					<button v-if="hasNav" type="button" class="btn btn-sm btn-secondary" @click="getTotal('next')">다음 고객</button>
				</div>
			</div>
		</div>
		<div class="content" v-else-if="item">
			<div class="detail-page">
				<div class="detail-page--top">
					<div class="left">
						<div class="state">
							<span class="date">{{ $dateFormat(item.reg_date) }}</span>
							<span class="date">No. {{ item.client_uid }}</span>
							<p class="name">{{ $CLIENT_TYPE[item.client_type] }}</p>
						</div>
					</div>
					<div class="info">
						<div class="top">
							<button type="button" class="btn btn-sm btn-secondary">{{ item.mgr_level }}</button>
						</div>
					</div>
					<div class="input-box">
						<label class="label">고객명</label>
						<input type="text" class="form-control" :value="item.name" disabled />
						<label class="label">담당자</label>
						<input type="text" class="form-control" :value="item.mgr_mem_name" disabled />
						<label class="label">등록일시</label>
						<input type="date" class="form-control" :value="$dateFormat(item.reg_date)" disabled />
					</div>
					<div class="page">
						<button type="button" class="btn first" @click="getTotal('first')"><b-icon-chevron-double-left /></button>
						<button type="button" class="btn prev" @click="getTotal('prev')"><b-icon-chevron-left /></button>
						<input type="text" class="form-control" v-model="searchInfoData.idx" @keyup.enter="getTotal('sel_idx')" />
						&nbsp;&nbsp;/&nbsp;&nbsp;
						<input
							type="text"
							class="form-control"
							v-model="searchInfoData.totalCount"
							disabled
							style="background-color: white"
						/>
						<button type="button" class="btn next" @click="getTotal('next')"><b-icon-chevron-right /></button>
						<button type="button" class="btn last" @click="getTotal('last')"><b-icon-chevron-double-right /></button>
					</div>
					<div class="right"><button class="btn btn-sm btn-danger" @click.stop="btnUserDelete()">삭제</button></div>
				</div>
				<div class="detail-page--con">
					<div class="left m-r--2">
						<div class="con">
							<div class="tit">
								매수고객정보
								<button type="button" class="btn icon" @click="isRegisterPopupShow = true"><b-icon-pencil /></button>
								<button
									type="button"
									class="btn icon ud-pin"
									v-bind:class="{ on: state && state.pinned }"
									:title="state && state.pinned ? '목록 고정 해제' : '내 목록 맨 위에 고정'"
									@click="togglePin"
								>
									<b-icon-pin-angle-fill v-if="state && state.pinned" />
									<b-icon-pin-angle v-else />
									{{ state && state.pinned ? '고정됨' : '고정' }}
								</button>
							</div>
							<table class="table type-input">
								<colgroup>
									<col width="15%" />
									<col width="35%" />
									<col width="15%" />
									<col width="35%" />
								</colgroup>
								<tr>
									<th>고객명/고객분류</th>
									<td colspan="3">{{ item.name }}/{{ $CLIENT_TYPE[item.client_type] }}</td>
								</tr>
								<tr v-if="!isPartnerGuest">
									<th>연락처1</th>
									<td>
										{{ item.mobile }} <template v-if="item.mobile_memo">/ {{ item.mobile_memo }}</template>
										<!-- DB: 담당자·관리자가 아니면 서버가 가려서 보낸다. 조회사유를 남기면 원문으로 바뀐다(매도 소유자 연락처와 같은 규칙). -->
										<button type="button" class="btn icon" v-if="contactLocked" title="조회사유를 남기고 연락처 보기" @click="openContact">
											<b-icon-search />
										</button>
									</td>
									<th>찾는물건금액</th>
									<td>{{ item.find_money_s }}억 ~ {{ item.find_money_e }}억</td>
								</tr>
								<tr v-if="!isPartnerGuest">
									<th>연락처2</th>
									<td>
										{{ item.mobile2 }} <template v-if="item.mobile2_memo">/ {{ item.mobile2_memo }}</template>
										<button type="button" class="btn icon" v-if="contactLocked && item.mobile2" title="조회사유를 남기고 연락처 보기" @click="openContact">
											<b-icon-search />
										</button>
									</td>
									<th>보유현금</th>
									<td>{{ item.having_money }}억</td>
								</tr>
								<!-- 게스트: 연락처 없이 금액 정보만 노출(레이아웃 유지) -->
								<tr v-if="isPartnerGuest">
									<th>찾는물건금액</th>
									<td>{{ item.find_money_s }}억 ~ {{ item.find_money_e }}억</td>
									<th>보유현금</th>
									<td>{{ item.having_money }}억</td>
								</tr>
								<tr>
									<th>E-mail</th>
									<td>
										{{ item.email }}
										<button type="button" class="btn icon" v-if="contactLocked && item.email" title="조회사유를 남기고 연락처 보기" @click="openContact">
											<b-icon-search />
										</button>
									</td>
									<th>찾는물건위치</th>
									<td>{{ item.find_area }}</td>
								</tr>
								<tr>
									<th>관리메모</th>
									<td colspan="3">
										<div class="text" v-html="item.memo.split('\n').join('<br />')"></div>
									</td>
								</tr>
								<!-- CS 자동보류: 마지막 상담이력 작성일 + N일(CZ 부터 관리자 설정, 기본 30). 상담이력·답글을 쓰면 다시 N일. -->
								<tr v-if="state">
									<th>자동보류</th>
									<td colspan="3">
										<template v-if="state.hold.exempt">
											<span class="ud-dday is-exempt">자동보류 제외</span>
											<span class="ud-hold-note">
												{{ state.hold.exempt.reason_name || state.hold.exempt.reason }}
												<template v-if="state.hold.exempt.memo">({{ state.hold.exempt.memo }})</template>
												· {{ state.hold.exempt.set_mem_name }} {{ state.hold.exempt.set_at }}
											</span>
										</template>
										<template v-else-if="state.hold.applies">
											<span class="ud-dday" v-bind:class="'is-' + holdInfo.level" :title="holdInfo.title">{{ holdInfo.text }}</span>
											<span v-if="holdInfo.sub" class="ud-dday--sub">{{ holdInfo.sub }}</span>
											<span class="ud-hold-note">마지막 상담 {{ state.hold.baseDate }} 기준 {{ state.hold.days }}일</span>
										</template>
										<span v-else class="ud-hold-note">관리·계약 고객만 대상입니다.</span>
										<span class="ud-hold-btns" v-if="state.rights.canSet || state.rights.canClear">
											<button type="button" class="btn btn-xxsm btn-secondary" v-if="state.rights.canSet" @click="openExempt">
												{{ state.hold.exempt ? '제외 사유 변경' : '자동보류 제외' }}
											</button>
											<button
												type="button"
												class="btn btn-xxsm btn-red"
												v-if="state.hold.exempt && state.rights.canClear"
												@click="btnExemptClear"
											>
												제외 해제
											</button>
										</span>
										<span
											v-else-if="!isPartnerGuest && !state.hold.exempt && state.hold.applies"
											class="ud-hold-note"
											:title="state.rights.quota != null ? '한도 ' + state.rights.quota + '건 중 ' + state.rights.used + '건 사용' : ''"
										>
											{{ exemptBlockedText }}
										</span>
									</td>
								</tr>
								<!-- CS 내 탭: 나에게만 보이는 분류. 눌러서 넣고 뺀다(한 고객을 여러 탭에). -->
								<tr v-if="state">
									<th>내 탭</th>
									<td colspan="3">
										<button
											v-for="t in myTabs"
											:key="'udt_' + t.tab_uid"
											type="button"
											class="btn ud-tab"
											v-bind:class="{ on: state.tabs.includes(t.tab_uid) }"
											:disabled="busy"
											@click="toggleTab(t)"
										>
											{{ t.tab_name }}
										</button>
										<button type="button" class="btn ud-tab ud-tab--add" :disabled="busy" @click="btnQuickTab">+ 새 탭</button>
									</td>
								</tr>
							</table>
						</div>
						<div class="con">
							<div class="tab-btn">
								<button
									type="button"
									class="btn tab"
									v-bind:class="{ active: logMode == false }"
									@click="logMode = false"
								>
									상담이력
								</button>
								<button
									type="button"
									class="btn tab"
									v-bind:class="{ active: logMode == true }"
									@click="logMode = true"
								>
									변경내역
								</button>
								<!-- DC: 카톡 대화·통화 녹음을 쌓는 자리. 열 때만 불러온다. 제휴 게스트는 쓰지 않는다(서버도 막는다). -->
								<button
									v-if="!isPartnerGuest"
									type="button"
									class="btn tab"
									v-bind:class="{ active: logMode === 'talk' }"
									@click="logMode = 'talk'"
								>
									대화 자료
								</button>
							</div>
							<template v-if="logMode == false">
								<div class="input-top">
									<select class="form-control select" v-model="counselInfo.id">
										<option :value="t.ind_cfg_uid" :key="'ccc_' + t.ind_cfg_uid" v-for="t in counselTypeList">
											{{ t.cfg_val1 }}
										</option>
									</select>
									<input
										type="text"
										class="form-control"
										placeholder="상담내용을 입력하고 엔터를 누르시면 저장됩니다"
										v-model="counselInfo.data"
										@keyup.enter="btnSaveCounsel()"
									/>
									<label v-if="isCallCounsel()" class="input-checkbox" style="margin-left: 8px; white-space: nowrap" title="받지 않은 통화는 부재로 따로 셉니다">
										<input type="checkbox" v-model="counselInfo.missed" />
										<span class="checkbox"></span>
										<span class="text">부재</span>
									</label>
								</div>
								<table class="table ud-counsel">
									<tr>
										<th>번호</th>
										<th>상담일자</th>
										<th>상담자</th>
										<th>상담구분</th>
										<th width="50%">상담내용</th>
										<th>답글</th>
									</tr>
									<template v-for="(item, idx) in counselList" :key="item.mgr_log_uid">
										<tr>
											<td>{{ idx + 1 }}</td>
											<td>{{ item.rDate }}</td>
											<td>{{ item.mem_name }} {{ item.mem_rank_name }}</td>
											<td>
												{{ item.counsel_type_name }}<span v-if="item.call_result === 'missed'" class="txt-c--red"> (부재)</span>
											</td>
											<td>
												<div class="txt-left">{{ item.memo }}</div>
											</td>
											<td>
												<button type="button" class="btn ud-reply-btn" @click="openReply(item)">
													<b-icon-reply />
													<template v-if="item.replies && item.replies.length">{{ item.replies.length }}</template>
												</button>
											</td>
										</tr>
										<!-- 답글(대댓글): 최초 상담과 이후 고객 반응을 한 흐름으로 본다. -->
										<tr v-for="r in item.replies || []" :key="'rp_' + r.reply_uid" class="ud-reply">
											<td></td>
											<td class="ud-reply--date"><b-icon-arrow-return-right /> {{ r.rDate }}</td>
											<td>{{ r.mem_name }} {{ r.mem_rank_name }}</td>
											<td>답글</td>
											<td>
												<div class="txt-left">{{ r.memo }}</div>
											</td>
											<td>
												<button
													type="button"
													class="btn icon type2 red"
													v-if="canDeleteReply(r)"
													title="답글 삭제"
													@click="btnReplyDelete(r)"
												>
													<b-icon-trash />
												</button>
											</td>
										</tr>
										<tr v-if="replyTarget === item.mgr_log_uid" class="ud-reply ud-reply--input">
											<td></td>
											<td class="ud-reply--date"><b-icon-arrow-return-right /></td>
											<td colspan="3">
												<input
													type="text"
													class="form-control"
													placeholder="답글을 입력하고 엔터를 누르시면 저장됩니다 (예: 답사 다녀왔으나 도로 경사가 심해 패스)"
													v-model="replyText"
													maxlength="2000"
													@keyup.enter="btnReplySave(item)"
												/>
											</td>
											<td>
												<button type="button" class="btn btn-xxsm btn-secondary" :disabled="busy" @click="btnReplySave(item)">저장</button>
											</td>
										</tr>
									</template>
								</table>
							</template>
							<ClientTalkPanel v-else-if="logMode === 'talk'" :cid="id" />
							<template v-else>
								<table class="table">
									<tr>
										<th>번호</th>
										<th>변경일자</th>
										<th>처리자</th>
										<th>변경구분</th>
										<th width="50%">변경내용</th>
									</tr>
									<tr v-for="(item, idx) in chgList" :key="item.mgr_log_uid">
										<td>{{ idx + 1 }}</td>
										<td>{{ item.mDate }}</td>
										<td>{{ item.mem_name }} {{ item.mem_rank_name }}</td>
										<td>{{ $CLIENT_LOG_TYPE[item.sub_type_key] || CLIENT_LOG_TYPE_EXTRA[item.sub_type_key] }}</td>
										<td>
											<div class="txt-left">{{ item.memo }}</div>
										</td>
									</tr>
								</table>
							</template>
						</div>
						<div class="con">
							<div class="tab-btn">
								<button
									type="button"
									class="btn tab"
									v-bind:class="{ active: briefMode == 'ready' }"
									@click="briefMode = 'ready'"
								>
									브리핑대기
								</button>
								<button
									type="button"
									class="btn tab"
									v-bind:class="{ active: briefMode == 'done' }"
									@click="briefMode = 'done'"
								>
									브리핑완료
								</button>
								<div class="right">
									<button type="button" class="btn btn-sm btn-secondary" @click="btnOnPrint">연쇄출력추가</button>
								</div>
							</div>
							<table class="table" v-if="briefMode == 'ready'">
								<tr>
									<th>상태</th>
									<th>물건번호</th>
									<th>물건명</th>
									<th>주소</th>
									<th>매매금액</th>
									<th>수익률</th>
									<th>완료/출력</th>
									<th>
										<label class="input-checkbox">
											<input type="checkbox" v-model="printSt" @change="setPrintAllSt" />
											<span class="checkbox"></span>
										</label>
									</th>
								</tr>
								<template v-for="item in briefList" :key="'cde_' + item.client_building_link_uid">
									<template v-if="item.brief_status == briefMode">
										<tr @click="btnOnDetail(item.building_uid, null, 'brief')">
											<td>{{ $ITEM_STATE[item.sell_status] }}</td>
											<td>{{ item.building_uid }}</td>
											<td>{{ item.building_name }}</td>
											<td>{{ item.jibun_addr }}<br />{{ item.road_addr }}</td>
											<td>
												<span class="txt-c--red">{{ $formatMoney(item.sell_price, $MONEY_FORMAT_TYPE.MUCH) }}</span>
											</td>
											<td>{{ item.earning_rate }}%</td>
											<td @click.stop>
												<button type="button" class="btn icon type2 yellow" @click="item.state = !item.state">
													<b-icon-eye />
												</button>
												<button type="button" class="btn icon type2"><b-icon-printer /></button>
												<button
													type="button"
													class="btn icon type2 red"
													@click="btnDeleteBrief(item.client_building_link_uid)"
												>
													<b-icon-trash />
												</button>
											</td>
											<td @click.stop>
												<label class="input-checkbox">
													<input type="checkbox" v-model="item.printSt" />
													<span class="checkbox"></span>
												</label>
											</td>
										</tr>
										<tr v-if="item.state">
											<td colspan="4" class="ud-brief-hint">브리핑금액을 적고 완료 처리하면 완료 일시가 자동으로 남습니다.</td>
											<td>브리핑금액</td>
											<td colspan="2">
												<input
													type="number"
													class="form-control"
													v-model="item.brief_price"
													@keyup.enter="btnSaveBrief(item)"
												/>
												<span class="text">억</span>
											</td>
											<td class="ud-brief-act">
												<button type="button" class="btn btn-xxsm btn-primary" :disabled="busy" @click="btnSaveBrief(item)">완료 처리</button>
												<button type="button" class="btn btn-xxsm btn-red" @click="item.state = false">취소</button>
											</td>
										</tr>
									</template>
								</template>
							</table>
							<table class="table" v-else>
								<tr>
									<th>상태</th>
									<th>물건번호</th>
									<th>물건명</th>
									<th>주소</th>
									<th>매매금액</th>
									<th>브리핑금액</th>
									<th>수익률</th>
									<th>완료일시</th>
									<th>출력</th>
									<th>
										<label class="input-checkbox">
											<input type="checkbox" v-model="printSt" @change="setPrintAllSt" />
											<span class="checkbox"></span>
										</label>
									</th>
								</tr>
								<template v-for="item in briefList" :key="'cde_' + item.client_building_link_uid">
									<template v-if="item.brief_status == briefMode">
										<tr @click="btnOnDetail(item.building_uid, null, 'brief')">
											<td>{{ $ITEM_STATE[item.sell_status] }}</td>
											<td>{{ item.building_uid }}</td>
											<td>{{ item.building_name }}</td>
											<td>{{ item.jibun_addr }}<br />{{ item.road_addr }}</td>
											<td>
												<span class="txt-c--red">{{ $formatMoney(item.sell_price, $MONEY_FORMAT_TYPE.MUCH) }}</span>
											</td>
											<td>
												<span class="txt-c--red">{{ $formatMoney(item.brief_price, $MONEY_FORMAT_TYPE.MUCH) }}</span>
											</td>
											<td>{{ item.earning_rate }}%</td>
											<td class="ud-done-at" :title="item.brief_done_cnt > 1 ? '이 물건을 ' + item.brief_done_cnt + '번 브리핑했습니다' : ''">
												{{ item.brief_done_at || '-' }}
												<span v-if="item.brief_mem_name" class="ud-done-at--who">{{ item.brief_mem_name }}</span>
												<span v-if="item.brief_done_cnt > 1" class="ud-done-at--who">{{ item.brief_done_cnt }}회</span>
											</td>
											<td>
												<button type="button" class="btn icon type2"><b-icon-printer /></button>
											</td>
										</tr>
									</template>
								</template>
							</table>
						</div>
					</div>
					<div class="right">
						<!-- CS 매물 검색: 매매검색(TotalSearch)의 상세검색을 그대로 쓴다(조건·요청 모두 utils/sellSearch.mjs).
						     고른 매물은 이 고객의 브리핑대기로 바로 들어간다. -->
						<div class="con ud-search">
							<div class="input-top">
								<label class="input-label">검색키워드</label>
								<input
									type="text"
									class="form-control"
									placeholder="물건명, 주소, 소유자, 전소유자, 전화번호"
									maxlength="80"
									v-model="sellOptions_.keyword"
									@keyup.enter="btnSellSearch"
								/>
								<button type="button" class="btn btn-xsm btn-secondary" @click="btnSellSearch">검색</button>
								<button type="button" class="btn btn-xsm btn-primary" @click="isSellDetailShow = true">
									<b-icon-funnel-fill /> 상세검색
								</button>
							</div>
							<div class="input-top">
								<label class="input-label">매물상태</label>
								<label class="input-checkbox">
									<input type="checkbox" v-model="sellOptions_.st" @change="btnSellStOption" />
									<span class="checkbox"></span>
									<span class="text">전체</span>
								</label>
								<label class="input-checkbox">
									<input type="checkbox" v-model="sellOptions_.st_" :value="'ready'" />
									<span class="checkbox"></span>
									<span class="text">준비</span>
								</label>
								<label class="input-checkbox">
									<input type="checkbox" v-model="sellOptions_.st_" :value="'done'" />
									<span class="checkbox"></span>
									<span class="text">매물</span>
								</label>
								<label class="input-checkbox">
									<input type="checkbox" v-model="sellOptions_.st_" :value="'hold'" />
									<span class="checkbox"></span>
									<span class="text">보류</span>
								</label>
								<label class="input-checkbox">
									<input type="checkbox" v-model="sellOptions_.st_" :value="'sell'" />
									<span class="checkbox"></span>
									<span class="text">매각</span>
								</label>
								<label class="input-checkbox" title="매물등록일자 기준 최근 1년 이내만 표시">
									<input type="checkbox" v-model="sellRecentYear" @change="onSellRecentYear" />
									<span class="checkbox"></span>
									<span class="text">최근 1년 등록만</span>
								</label>
								<span class="ud-search--cnt" v-if="buildingPage.totalCount != null">검색결과 {{ buildingPage.totalCount }}건</span>
							</div>
							<div v-if="sellFilterTags.length" class="ud-search--tags">
								<span v-for="tg in sellFilterTags" :key="'sft_' + tg" class="ud-chip">{{ tg }}</span>
								<button type="button" class="btn ud-search--reset" @click="btnSellReset">조건 초기화</button>
							</div>
							<table class="table ud-sell">
								<tr>
									<th>
										<label class="input-checkbox" title="이 쪽 전체 선택">
											<input type="checkbox" :checked="sellAllChecked" @change="toggleSellAll($event.target.checked)" />
											<span class="checkbox"></span>
										</label>
									</th>
									<th>상태</th>
									<th>물건번호</th>
									<th>물건명</th>
									<th>주소</th>
									<th>용도지역</th>
									<th>대지(평)</th>
									<th>연면적(평)</th>
									<th>매매가</th>
									<th>수익률</th>
								</tr>
								<tr
									v-for="(item, idx) in buildingList"
									:key="'dbid_' + item.building_uid"
									@click="btnOnDetail(item.building_uid, idx, 'total')"
								>
									<td @click.stop>
										<label class="input-checkbox">
											<input type="checkbox" v-model="addBriefList2" :value="item.building_uid" />
											<span class="checkbox"></span>
										</label>
										<span v-if="briefStatusOf(item.building_uid)" class="ud-chip">
											{{ briefStatusOf(item.building_uid) === 'done' ? '완료' : '대기' }}
										</span>
									</td>
									<td>
										<span
											v-bind:class="{
												'txt-c--blue': item.sell_status == 'done',
												'txt-c--grey': item.sell_status == 'ready',
												'txt-c--red': item.sell_status == 'sell',
											}"
										>
											{{ $ITEM_STATE[item.sell_status] }}
										</span>
									</td>
									<td>{{ item.building_uid }}</td>
									<td>{{ item.building_name }}</td>
									<td class="ud-sell--addr" :title="item.road_addr">{{ item.jibun_addr }}</td>
									<td>{{ item.cfg_val1 }}</td>
									<td>{{ $formatArea(item.land_size_p) }}</td>
									<td>{{ $formatArea(item.total_size_p) }}</td>
									<td>{{ $formatMoney(item.sell_price, $MONEY_FORMAT_TYPE.MUCH) }}</td>
									<td>{{ item.total_income_rate }}</td>
								</tr>
								<tr v-if="sellLoaded && !buildingList.length">
									<td colspan="10">조건에 맞는 매물이 없습니다.</td>
								</tr>
							</table>
							<ul
								class="pagination b-pagination pagination-sm"
								v-if="buildingPage.pageData != null && buildingPage.pageData.list.length"
							>
								<li class="page-item" v-bind:class="{ disabled: 1 == buildingPage.page }">
									<button type="button" class="page-link" @click="getBuildingList(1)">
										<b-icon-chevron-double-left />
									</button>
								</li>

								<li class="page-item" v-bind:class="{ disabled: buildingPage.pageData.first == null }">
									<button
										type="button"
										class="page-link"
										@click="buildingPage.pageData.first !== null ? getBuildingList(buildingPage.pageData.first) : ''"
									>
										<b-icon-chevron-left />
									</button>
								</li>
								<li
									v-for="pg in buildingPage.pageData.list"
									v-bind:key="'pg_' + pg"
									class="page-item"
									v-bind:class="{ active: buildingPage.pageData.currentPage == pg }"
								>
									<button type="button" class="page-link" @click="getBuildingList(pg)">{{ pg }}</button>
								</li>
								<li class="page-item" v-bind:class="{ disabled: buildingPage.pageData.end == null }">
									<button
										type="button"
										class="page-link"
										@click="buildingPage.pageData.end !== null ? getBuildingList(buildingPage.pageData.end) : ''"
									>
										<b-icon-chevron-right />
									</button>
								</li>

								<li class="page-item" v-bind:class="{ disabled: buildingPage.pageData.totalPage == buildingPage.page }">
									<button type="button" class="page-link" @click="getBuildingList(buildingPage.pageData.totalPage)">
										<b-icon-chevron-double-right />
									</button>
								</li>
							</ul>

							<div class="btn-wrap m-3 mb-2">
								<button type="button" class="btn btn-sm btn-secondary" :disabled="busy" @click="btnAddBrief2">
									선택 {{ addBriefList2.length }}건 브리핑대기 물건저장
								</button>
							</div>
						</div>
						<div class="con">
							<div class="tit">최근물건</div>
							<table class="table">
								<tr>
									<th>브리핑</th>
									<th>상태</th>
									<th>물건번호</th>
									<th>물건명</th>
									<th>주소</th>
									<th>용도지역</th>
									<th>대지면적</th>
									<th>연면적</th>
									<th>매매금액</th>
								</tr>
								<tr
									v-for="(item, idx) in countList"
									:key="'de_' + item.building_view_log_uid"
									@click="btnOnDetail(item.building_uid, idx, 'user_count')"
								>
									<td @click.stop>
										<label class="input-checkbox">
											<input type="checkbox" v-model="addBriefList" :value="item.building_uid" />
											<span class="checkbox"></span>
										</label>
									</td>
									<td>{{ $ITEM_STATE[item.sell_status] }}</td>
									<td>{{ item.building_uid }}</td>
									<td>{{ item.building_name }}</td>
									<td>{{ item.jibun_addr }}<br />{{ item.road_addr }}</td>
									<td>{{ item.use_area_name }}</td>
									<td>{{ $formatArea(item.land_size_p) }}<br />{{ $formatArea(item.land_size_m2) }}</td>
									<td>{{ $formatArea(item.total_size_p) }}<br />{{ $formatArea(item.total_size_m2) }}</td>
									<td>{{ $formatMoney(item.sell_price, $MONEY_FORMAT_TYPE.MUCH) }}</td>
								</tr>
							</table>

							<ul
								class="pagination b-pagination pagination-sm"
								v-if="countPage.pageData != null && countPage.pageData.list.length"
							>
								<li class="page-item" v-bind:class="{ disabled: 1 == countPage.page }">
									<button type="button" class="page-link" @click="getCountList(1)">
										<b-icon-chevron-double-left />
									</button>
								</li>

								<li class="page-item" v-bind:class="{ disabled: countPage.pageData.first == null }">
									<button
										type="button"
										class="page-link"
										@click="countPage.pageData.first !== null ? getCountList(countPage.pageData.first) : ''"
									>
										<b-icon-chevron-left />
									</button>
								</li>
								<li
									v-for="pg in countPage.pageData.list"
									v-bind:key="'pg_' + pg"
									class="page-item"
									v-bind:class="{ active: countPage.pageData.currentPage == pg }"
								>
									<button type="button" class="page-link" @click="getCountList(pg)">{{ pg }}</button>
								</li>
								<li class="page-item" v-bind:class="{ disabled: countPage.pageData.end == null }">
									<button
										type="button"
										class="page-link"
										@click="countPage.pageData.end !== null ? getCountList(countPage.pageData.end) : ''"
									>
										<b-icon-chevron-right />
									</button>
								</li>

								<li class="page-item" v-bind:class="{ disabled: countPage.pageData.totalPage == countPage.page }">
									<button type="button" class="page-link" @click="getCountList(countPage.pageData.totalPage)">
										<b-icon-chevron-double-right />
									</button>
								</li>
							</ul>

							<div class="btn-wrap m-3 mb-2">
								<button type="button" class="btn btn-sm btn-secondary" @click="btnAddBrief">브리핑대기 물건저장</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div v-if="isRegisterPopupShow" class="popup-wrap">
		<div class="dim" @click="isRegisterPopupShow = false"></div>
		<div class="popup sm">
			<div class="popup-tit">
				매수고객정보
				<button type="button" class="btn btn-close" @click="isRegisterPopupShow = false"><b-icon-x-lg /></button>
			</div>
			<div class="popup-con">
				<table class="table type-input">
					<tr v-if="!isPartnerGuest">
						<th>담당자</th>
						<td>
							<select v-model="addInfo.mgrUid" class="form-control select">
								<option value="" selected>전체</option>
								<option v-for="c in memList" :key="'clienttype_' + c.ind_cfg_uid" :value="c.mem_uid">
									{{ c.mem_name }} {{ c.mem_rank_name }}
								</option>
							</select>
						</td>
					</tr>
					<tr>
						<th>고객구분</th>
						<td>
							<label class="input-checkbox">
								<input type="radio" name="radio1" v-model="addInfo.clientType" :value="'manage'" />
								<span class="checkbox radio"></span>
								<span class="text">관리</span>
							</label>
							<label class="input-checkbox" v-if="!isPartnerGuest">
								<input type="radio" name="radio1" v-model="addInfo.clientType" :value="'none'" />
								<span class="checkbox radio"></span>
								<span class="text">미관리</span>
							</label>
							<label class="input-checkbox" v-if="!isPartnerGuest">
								<input type="radio" name="radio1" v-model="addInfo.clientType" :value="'property'" />
								<span class="checkbox radio"></span>
								<span class="text">부동산</span>
							</label>
							<label class="input-checkbox" v-if="!isPartnerGuest">
								<input type="radio" name="radio1" v-model="addInfo.clientType" :value="'black'" />
								<span class="checkbox radio"></span>
								<span class="text">블랙</span>
							</label>
							<label class="input-checkbox">
								<input type="radio" name="radio1" v-model="addInfo.clientType" :value="'contract'" />
								<span class="checkbox radio"></span>
								<span class="text">계약</span>
							</label>
						</td>
					</tr>
					<tr>
						<th>관리등급</th>
						<td>
							<label class="input-checkbox">
								<input type="radio" name="radio2" v-model="addInfo.mgrLevel" :value="'A'" />
								<span class="checkbox radio"></span>
								<span class="text">A</span>
							</label>
							<label class="input-checkbox">
								<input type="radio" name="radio2" v-model="addInfo.mgrLevel" :value="'B'" />
								<span class="checkbox radio"></span>
								<span class="text">B</span>
							</label>
							<label class="input-checkbox">
								<input type="radio" name="radio2" v-model="addInfo.mgrLevel" :value="'C'" />
								<span class="checkbox radio"></span>
								<span class="text">C</span>
							</label>
						</td>
					</tr>
					<tr>
						<th>고객명</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="text" v-model="addInfo.clientName" />
							</div>
						</td>
					</tr>
					<tr v-if="!isPartnerGuest">
						<th>연락처1</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="tel" placeholder="연락처" maxlength="20" :value="addInfo.clientMobile1" :disabled="contactMasked" @input="onPhoneInput($event, 'clientMobile1')" />
								<input class="form-control" type="text" placeholder="메모" v-model="addInfo.clientMobileMemo1" />
							</div>
						</td>
					</tr>
					<tr v-if="!isPartnerGuest">
						<th>연락처2</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="tel" placeholder="연락처" maxlength="20" :value="addInfo.clientMobile2" :disabled="contactMasked" @input="onPhoneInput($event, 'clientMobile2')" />
								<input class="form-control" type="text" placeholder="메모" v-model="addInfo.clientMobileMemo2" />
							</div>
						</td>
					</tr>
					<tr>
						<th>이메일</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="email" v-model="addInfo.clientEmail" :disabled="contactMasked" />
							</div>
							<p class="ud-contact-note" v-if="contactMasked">연락처와 이메일은 담당자와 관리자만 바꿀 수 있습니다.</p>
						</td>
					</tr>
					<tr>
						<th>찾는물건금액</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="number" v-model="addInfo.findMoneyS" />
								<span class="form-text">억 ~ </span>
								<input class="form-control" type="number" v-model="addInfo.findMoneyE" />
								<span class="form-text">억</span>
							</div>
						</td>
					</tr>
					<tr>
						<th>보유현금</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="number" v-model="addInfo.havingMoney" />
								<span class="form-text">억</span>
							</div>
						</td>
					</tr>
					<tr>
						<th>찾는위치</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="text" v-model="addInfo.findArea" />
							</div>
						</td>
					</tr>
					<tr>
						<th>관리메모</th>
						<td>
							<div class="form-wrap">
								<textarea class="form-control" v-model="addInfo.clientMemo"></textarea>
							</div>
						</td>
					</tr>
				</table>
				<div class="btn-wrap">
					<button type="button" class="btn btn-sm btn-secondary" @click="isRegisterPopupShow = false">취소</button>
					<button type="button" class="btn btn-sm btn-primary" @click="btnUserUpdate()">저장</button>
				</div>
			</div>
		</div>
	</div>

	<!-- CS 자동보류 제외: 이름·문구 검색이 아니라 고객에게 값을 직접 붙인다. -->
	<div v-if="isExemptShow" class="popup-wrap">
		<div class="dim" @click="isExemptShow = false"></div>
		<div class="popup sm">
			<div class="popup-tit">
				자동보류 제외
				<button type="button" class="btn btn-close" @click="isExemptShow = false"><b-icon-x-lg /></button>
			</div>
			<div class="popup-con">
				<p class="ud-help">
					제외한 고객은 마지막 상담 후 {{ (state && state.hold && state.hold.days) || 30 }}일이 지나도 자동보류 대상으로 보지 않고, 목록에 D-day 대신 '자동보류 제외' 로
					표시됩니다. 누가 어떤 사유로 제외했는지는 관리자 화면에 남습니다.
					<span v-if="state && !state.rights.isMaster && state.rights.quota != null">
						내 제외 한도 {{ state.rights.quota }}건 중 {{ state.rights.used }}건 사용.
					</span>
				</p>
				<table class="table type-input">
					<colgroup>
						<col width="20%" />
						<col />
					</colgroup>
					<tr>
						<th>제외 사유</th>
						<td>
							<label class="input-checkbox" v-for="r in exemptReasonOptions" :key="'hr_' + r.reason_key">
								<input type="radio" name="hold_reason" v-model="exemptForm.reason" :value="r.reason_key" />
								<span class="checkbox radio"></span>
								<span class="text">{{ r.reason_name }}<template v-if="r.use_flag !== 'Y'"> (사용 안 함)</template></span>
							</label>
							<span v-if="!exemptReasonOptions.length" class="ud-hold-note">관리자가 등록한 제외 사유가 없습니다.</span>
						</td>
					</tr>
					<tr>
						<th>메모</th>
						<td>
							<div class="form-wrap">
								<input
									class="form-control"
									type="text"
									maxlength="100"
									:placeholder="exemptMemoRequired ? '이 사유는 메모를 꼭 적어 주세요' : '예: 최선장 / 땅땅 / 구해줘빌딩 유입 (선택)'"
									v-model="exemptForm.memo"
								/>
							</div>
						</td>
					</tr>
				</table>
				<div class="btn-wrap">
					<button type="button" class="btn btn-sm btn-secondary" @click="isExemptShow = false">취소</button>
					<button type="button" class="btn btn-sm btn-primary" :disabled="busy" @click="btnExemptSave">저장</button>
				</div>
			</div>
		</div>
	</div>

	<!-- DB 매수고객정보확인: 매도 소유자정보확인(MapDetail)과 같은 꼴. 조회사유를 고르고 비밀번호(고객번호)를 넣는다. -->
	<div v-if="isContactPopupShow" class="popup-wrap">
		<div class="dim" @click="isContactPopupShow = false"></div>
		<div class="popup sm">
			<div class="popup-tit">
				매수고객정보확인
				<button type="button" class="btn btn-close" @click="isContactPopupShow = false"><b-icon-x-lg /></button>
			</div>
			<div class="popup-con">
				<table class="table type-input">
					<tr>
						<th>조회사유</th>
						<td>
							<select class="form-control select" v-model="contactPopup.selectData">
								<option value="">선택</option>
								<option v-for="(r, idx) in $CLIENT_CONTACT_REASON" :key="'ccr_' + idx" :value="r">{{ r }}</option>
							</select>
							<div class="form-wrap" v-if="contactPopup.selectData == '직접입력'">
								<input class="form-control" type="text" maxlength="200" v-model="contactPopup.data" />
							</div>
						</td>
					</tr>
					<tr>
						<th>비밀번호</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="password" placeholder="비밀번호를 입력하세요." v-model="contactPopup.passwd" @keyup.enter="sendContact" />
							</div>
						</td>
					</tr>
				</table>
				<div class="btn-wrap mt-3">
					<button type="button" class="btn btn-md btn-primary" :disabled="contactBusy" @click="sendContact">확인</button>
				</div>
			</div>
		</div>
	</div>

	<SellDetailSearchPopup
		v-if="isSellDetailShow"
		:options="sellOptions_"
		@search="onSellDetailSearch"
		@clear="resetSellOptions"
		@close="onSellDetailClose"
	/>
</template>

<script>
import SellDetailSearchPopup from '@/components/SellDetailSearchPopup.vue';
import ClientTalkPanel from '@/components/ClientTalkPanel.vue';
import {
	defaultSellSearchOptions,
	normalizeSellSearch,
	recentYearWindow,
	sellSearchParams,
	sellFilterTags as buildSellFilterTags,
	SELL_STATUS_ALL,
} from '@/utils/sellSearch.mjs';
import { holdBadge, CLIENT_LOG_TYPE_EXTRA } from '@/utils/clientManage.mjs';
import { formatPhone } from '@/utils/phone.mjs';

// 상세검색에서 고른 조건을 매물 표 위에 이름만 보여 준다(좁은 패널에서 '지금 무엇으로 걸렀는지' 가 보이게).
export default {
	name: 'UserDetail',
	props: {
		cid: { type: Number },
	},
	components: { SellDetailSearchPopup, ClientTalkPanel },
	created() {
		this.id = this.$route.params.id;

		this.searchInfoData = { ...this.$route.query };

		this.init();
		this.loadNavIds();
	},
	data() {
		return {
			id: null,
			item: null,
			isRegisterPopupShow: false,
			memList: [],
			buildingList: [],
			countList: [],
			briefList: [],
			addBriefList: [],
			addBriefList2: [],
			counselList: [],
			chgList: [],
			counselTypeList: [],
			briefMode: 'ready',
			logMode: false,

			printSt: false,

			counselInfo: {
				id: null,
				data: '',
				missed: false,
			},

			addInfo: {
				mgrUid: '',
				mgrLevel: 'C',
				clientType: '',
				clientName: '',
				clientMobile1: '',
				clientMobile2: '',
				clientMobileMemo1: '',
				clientMobileMemo2: '',
				clientEmail: '',
				clientMemo: '',
				findMoneyS: 0,
				findMoneyE: 0,
				havingMoney: 0,
				findArea: '',
				cid: null,
			},

			// CS: 핀·내 탭·자동보류 상태(/user/admin/client/state)와 내 탭 목록
			state: null,
			myTabs: [],
			busy: false,
			CLIENT_LOG_TYPE_EXTRA,
			isExemptShow: false,
			exemptReasons: [],
			exemptForm: { reason: '', memo: '' },
			// '' | 'scope'(열람범위 밖, 403) | 'error'(그 밖의 실패)
			denied: '',
			// 카드를 다시 그릴 때마다 하나씩 올린다. 늦게 온 옛 응답(A→B→A 처럼 같은 고객으로 돌아온 경우 포함)을 버린다.
			loadSeq: 0,
			// DB: 가린 연락처를 조회사유를 남기고 연 뒤인가. 고객이 바뀌면 다시 닫는다.
			contactView: false,
			isContactPopupShow: false,
			contactPopup: { selectData: '', data: '', passwd: '' },
			contactBusy: false,
			// 상태·상담 요청별 순번. 같은 고객에서 가린 요청과 원문(reveal) 요청이 겹치면 마지막 요청의 응답만 쓴다.
			stateSeq: 0,
			counselSeq: 0,
			// 상태·상담 요청에 reveal=1 을 붙일지. 화면의 열림 표시(contactView)와 따로 둔다: 저장 뒤 다시 읽는 동안 화면은
			// 원문을 그대로 보이지만(돋보기가 깜빡이지 않게), 그 사이 핀 변경·상담 저장이 다시 묻는 요청은 가린 값이어야 한다(codex 리뷰).
			revealReq: false,
			replyTarget: null,
			replyText: '',

			// CS: 매물 검색 = 매매검색 상세검색. sellOptions_ 는 입력 중인 값, sellOptions 는 검색에 쓴 값.
			// 이전·다음 이동에 쓰는, 창을 연 순간의 목록 순서(고객 번호). 목록에서 연 창이 아니면 null.
			navIds: null,
			// '최근 1년 등록만' 으로 마지막에 채운 등록일 창. 상세검색에서 날짜를 고쳤는지 이것과 비교한다.
			sellRecentWin: null,
			sellOptions_: defaultSellSearchOptions(),
			sellOptions: normalizeSellSearch(defaultSellSearchOptions()),
			// 표 위 조건 태그는 검색에 **쓴** 입력값으로 그린다(팝업에서 고치는 중인 값이 아니라).
			sellAppliedRaw: defaultSellSearchOptions(),
			sellAppliedRecent: true,
			sellRecentYear: true,
			sellLoaded: false,
			isSellDetailShow: false,

			countPage: {
				page: 1,
				pageData: null,
				totalCount: null,
				itemSize: 5,
				blockSize: 5,
			},

			buildingPage: {
				page: 1,
				pageData: null,
				totalCount: null,
				itemSize: 20, // /admin/api/total(SP_TOTAL_SEARCH)은 한 쪽 20건 고정
				blockSize: 5,
			},

			searchInfoData: null,
		};
	},
	computed: {
		// DB: 서버가 이 고객의 연락처를 가려서 보냈는가(담당자·관리자가 아니다). 조회사유로 연 뒤에도 true 다(수정은 계속 막는다).
		contactMasked() {
			return !!(this.item && this.item.contact_masked);
		},
		contactLocked() {
			return this.contactMasked && !this.contactView;
		},
		// 목록에서 연 창(순번이 실려 옴)이면 막힌 카드에서도 이전·다음으로 넘어갈 수 있다.
		hasNav() {
			const q = this.searchInfoData;
			return !!(q && q.idx != null && q.idx !== '');
		},
		// 제휴기관 게스트(신한/대신) — 담당자/연락처/고객구분 일부 숨김 분기.
		isPartnerGuest() {
			return this.$store.getters.getPartnerGuest;
		},
		myUid() {
			return Number(this.$store.getters.getUserInfo.mem_uid);
		},
		holdInfo() {
			if (!this.state) return { text: '', sub: '', level: 'none', title: '' };
			return holdBadge({
				dday: this.state.hold.dday,
				baseDate: this.state.hold.baseDate,
				days: this.state.hold.days,
				alertDays: this.state.hold.alertDays,
			});
		},
		sellAllChecked() {
			return this.buildingList.length > 0 && this.buildingList.every(b => this.addBriefList2.includes(b.building_uid));
		},
		// 제외 버튼이 없는 이유를 그대로 적는다(한도를 다 썼는지, 내 담당 고객이 아닌지).
		// CY: 직원은 한도 없이도 자기 담당 고객에게 건다. quota 가 null 이면 제한 없음이다.
		exemptBlockedText() {
			const r = this.state && this.state.rights;
			if (!r) return '';
			if (r.quota != null && r.used >= r.quota) {
				return r.quota > 0
					? '· 제외 한도 ' + r.quota + '건을 모두 사용했습니다. 한도는 관리자가 정합니다.'
					: '· 관리자가 이 계정의 자동보류 제외를 막아 두었습니다.';
			}
			return '· 자동보류 제외는 담당자 본인 또는 관리자가 걸 수 있습니다.';
		},
		// 고를 수 있는 사유: 켜진 사유 + (이미 걸린 제외의 사유가 꺼졌으면) 그 사유. 순서는 관리자가 정한 대로.
		exemptReasonOptions() {
			const cur = this.state && this.state.hold.exempt ? this.state.hold.exempt.reason : null;
			return this.exemptReasons.filter(r => r.use_flag === 'Y' || r.reason_key === cur);
		},
		exemptMemoRequired() {
			const r = this.exemptReasons.find(x => x.reason_key === this.exemptForm.reason);
			return !!(r && r.memo_required === 'Y');
		},
		sellFilterTags() {
			return buildSellFilterTags(this.sellAppliedRaw, { recentYear: this.sellAppliedRecent });
		},
		briefStatusMap() {
			const m = {};
			for (const b of this.briefList) m[b.building_uid] = b.brief_status;
			return m;
		},
	},
	methods: {
		// 연락처 칸 자동 하이픈(CU). 임대고객 화면과 같은 규칙이다. v-model 대신 직접 쓰는 이유: 지운 글자가
		// 값을 바꾸지 않으면(예: 숫자 뒤에 문자 입력) 화면이 다시 그려지지 않아 입력칸에 그대로 남는다.
		resetContact() {
			this.contactView = false;
			this.revealReq = false;
			this.isContactPopupShow = false;
			this.contactPopup = { selectData: '', data: '', passwd: '' };
			this.contactBusy = false;
		},
		openContact() {
			this.contactPopup = { selectData: '', data: '', passwd: '' };
			this.isContactPopupShow = true;
		},
		// DB: 매도 소유자정보확인(MapDetail sendPhone)과 같은 절차. 비밀번호는 고객번호다.
		// 서버가 조회사유를 먼저 기록하고 그 응답에 원문을 실어 준다. 기록이 실패하면 열지 않는다.
		sendContact() {
			const p = this.contactPopup;
			if (!p.selectData) {
				alert('조회사유를 선택하세요.');
				return;
			}
			const memo = p.selectData == '직접입력' ? String(p.data || '').trim() : p.selectData;
			if (!memo) {
				alert('조회사유를 입력하세요.');
				return;
			}
			if (!p.passwd) {
				alert('비밀번호를 입력하세요.');
				return;
			}
			if (!this.item || String(this.item.client_uid) !== String(p.passwd).trim()) {
				alert('비밀번호가 일치하지 않습니다.');
				return;
			}
			if (this.contactBusy) return;
			this.contactBusy = true;
			const seq = this.loadSeq;
			const cid = this.item.client_uid;
			// 수정 창 칸 → 원문 칸. 응답을 기다리는 사이 수정 창에서 고친 칸은 건드리지 않는다(쓰던 메모가 사라지지 않게).
			const fill = { clientMobile1: 'mobile', clientMobile2: 'mobile2', clientEmail: 'email', clientMobileMemo1: 'mobile_memo', clientMobileMemo2: 'mobile2_memo', clientMemo: 'memo' };
			const before = {};
			for (const k of Object.keys(fill)) before[k] = this.addInfo[k];
			this.$apiPOST('/admin/api/user/admin/detail/contact/reveal', { cid, memo }).then(re => {
				if (seq !== this.loadSeq) return; // 그 사이 다른 고객으로 넘어갔거나 저장 뒤 다시 읽었다
				this.contactBusy = false;
				if (!re || re.ok !== true || !re.contact) return;
				Object.assign(this.item, re.contact);
				// 수정 창의 칸도 원문으로 맞춘다. 연락처 칸은 잠겨 있고 서버가 저장 때 DB 값으로 되돌린다.
				for (const [k, col] of Object.entries(fill)) {
					if (this.addInfo[k] === before[k]) this.addInfo[k] = re.contact[col];
				}
				this.contactView = true;
				this.revealReq = true;
				this.isContactPopupShow = false;
				// 상담·변경내역·제외 메모 속 번호도 연다(서버가 방금 남긴 기록을 확인한다).
				this.getCounselList(true);
				this.getState(true);
			});
		},
		onPhoneInput(e, key) {
			const v = formatPhone(e.target.value);
			e.target.value = v;
			this.addInfo[key] = v;
		},
		async init() {
			// 이전·다음으로 넘어갈 때 앞 고객의 카드·핀·탭·D-day·제외 권한이 새 고객 카드에 남지 않게 먼저 비운다.
			// 카드(item)와 수정·제외 창까지 비우는 이유: 화면은 앞 고객인데 삭제·저장은 새 고객 번호로 나가는 틈이
			// 있었다(codex 리뷰 P0, 두 고객이 모두 내 담당이면 서버 가드도 못 막는다).
			const seq = ++this.loadSeq;
			this.state = null;
			this.denied = '';
			this.item = null;
			this.briefList = [];
			this.counselList = [];
			this.chgList = [];
			this.isRegisterPopupShow = false;
			this.isExemptShow = false;
			this.resetContact();
			// CY: 열람범위 밖 고객이면 서버가 카드 API 전부를 403 으로 막는다. 상태를 먼저 물어, 막히면 안내를
			// 한 번만 띄우고 나머지를 부르지 않는다(동시에 부르면 같은 안내가 네 번 뜬다).
			const ok = await this.getState();
			if (seq !== this.loadSeq) return; // 그 사이 다른 고객으로 넘어갔거나 다시 불렀다
			if (ok !== true) {
				this.item = null;
				this.denied = ok || 'error';
				return;
			}
			this.getItem();
			this.getMemList();
			this.getCountList(1);
			this.getMyTabs();
			this.getBriefList();
			this.getCounselList();
			this.getCounselTypeList();
			// 매물 검색은 첫 진입 때 한 번 기본 조건(매물 상태 '매물', 최근 1년)으로 띄운다.
			// 이전·다음 고객으로 넘어가도 직원이 걸어 둔 검색 조건은 그대로 둔다.
			if (!this.sellLoaded) {
				this.applySellRecent();
				this.btnSellSearch();
			}
		},
		// ── CS: 핀·내 탭·자동보류 ──
		// 성공하면 true, 403(범위 밖)이면 'scope', 그 밖의 실패면 'error'(공통 함수가 안내를 이미 띄웠다).
		// 일시 오류를 '범위 밖' 으로 말하면 담당자가 자기 고객을 못 보는 줄 안다(CY 리뷰).
		// reveal: 조회사유를 남기고 연 상태면 서버가 제외 메모도 원문으로 준다(DB). 기본은 지금 열림 상태.
		getState(reveal) {
			let failStatus = 0;
			const onError = s => {
				failStatus = s;
			};
			const rv = (reveal === undefined ? this.revealReq : reveal) ? '&reveal=1' : '';
			const load = this.loadSeq;
			const my = ++this.stateSeq;
			return this.$apiGET('/admin/api/user/admin/client/state?cid=' + this.id + rv, { onError }).then(data => {
				if (!data || !data.hold) return failStatus === 403 ? 'scope' : 'error';
				// 연타로 앞 고객의 응답이나, 저장·이동 뒤에 앞선 요청(원문일 수 있다)이 늦게 오면 버린다.
				// 원문 요청은 그 사이 열람 상태가 닫혔으면 쓰지 않는다.
				const stale = load !== this.loadSeq || my !== this.stateSeq || (rv && !this.revealReq);
				if (!stale && String(data.cid) === String(this.id)) this.state = data;
				return true;
			});
		},
		getMyTabs() {
			return this.$apiGET('/admin/api/user/admin/tab').then(data => {
				if (Array.isArray(data)) this.myTabs = data;
			});
		},
		async togglePin() {
			if (!this.state) return;
			const re = await this.$apiPOST('/admin/api/user/admin/pin', { cid: this.id, on: !this.state.pinned });
			if (re && re.ok) this.getState();
		},
		async toggleTab(t) {
			if (!this.state) return;
			const on = !this.state.tabs.includes(t.tab_uid);
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/user/admin/tab/assign', { tabUid: t.tab_uid, cids: [Number(this.id)], on });
				if (!re || !re.ok) return;
				await Promise.all([this.getState(), this.getMyTabs()]);
			} finally {
				this.busy = false;
			}
		},
		async btnQuickTab() {
			const raw = window.prompt('새 탭 이름 (20자 이내, 예: 집중관리)');
			const name = (raw || '').trim();
			if (!name) return;
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/user/admin/tab/add', { name });
				if (!re || !re.ok) return;
				await this.$apiPOST('/admin/api/user/admin/tab/assign', { tabUid: re.tab.tab_uid, cids: [Number(this.id)], on: true });
				await Promise.all([this.getState(), this.getMyTabs()]);
			} finally {
				this.busy = false;
			}
		},
		async openExempt() {
			// 사유는 관리자가 고치는 목록이라 창을 열 때마다 새로 받는다(CY). 받는 사이 다음 고객으로 넘어가면 열지 않는다
			// (늦은 응답이 새 고객 카드에서 창을 열어 그 고객에게 저장됐다. codex 리뷰).
			const seq = this.loadSeq;
			const list = await this.$apiGET('/admin/api/user/admin/hold/reason');
			if (seq !== this.loadSeq || !this.state) return;
			if (!Array.isArray(list)) return;
			this.exemptReasons = list;
			const ex = this.state && this.state.hold.exempt;
			const first = this.exemptReasonOptions[0];
			this.exemptForm = { reason: ex ? ex.reason : first ? first.reason_key : '', memo: ex && ex.memo ? ex.memo : '' };
			this.isExemptShow = true;
		},
		async btnExemptSave() {
			const memo = (this.exemptForm.memo || '').trim();
			if (!this.exemptForm.reason) {
				alert('제외 사유를 선택하세요.');
				return;
			}
			if (this.exemptMemoRequired && !memo) {
				alert('이 사유는 메모를 적어야 저장됩니다.');
				return;
			}
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/user/admin/hold/exempt', {
					cid: this.id,
					reason: this.exemptForm.reason,
					memo,
				});
				if (!re || !re.ok) return;
				this.isExemptShow = false;
				this.getState();
				this.getCounselList();
			} finally {
				this.busy = false;
			}
		},
		async btnExemptClear() {
			if (!confirm('자동보류 제외를 해제합니다. 마지막 상담일 기준 D-day 가 다시 표시됩니다.')) return;
			const re = await this.$apiPOST('/admin/api/user/admin/hold/exempt/clear', { cid: this.id });
			if (!re || !re.ok) return;
			this.getState();
			this.getCounselList();
		},
		// ── CS: 상담 답글 ──
		openReply(item) {
			this.replyTarget = this.replyTarget === item.mgr_log_uid ? null : item.mgr_log_uid;
			this.replyText = '';
		},
		canDeleteReply(r) {
			return Number(r.mem_uid) === this.myUid || !!(this.state && this.state.rights.isMaster);
		},
		async btnReplySave(item) {
			const memo = (this.replyText || '').trim();
			if (!memo) {
				alert('답글 내용을 입력하세요.');
				return;
			}
			if (this.busy) return;
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/user/admin/detail/counsel/reply/add', {
					cid: this.id,
					logUid: item.mgr_log_uid,
					memo,
				});
				if (!re || !re.ok) return;
				this.replyText = '';
				this.replyTarget = null;
				this.getCounselList();
				this.getState();
			} finally {
				this.busy = false;
			}
		},
		async btnReplyDelete(r) {
			if (!confirm('답글을 삭제하시겠습니까?')) return;
			const re = await this.$apiPOST('/admin/api/user/admin/detail/counsel/reply/delete', {
				cid: this.id,
				replyUid: r.reply_uid,
			});
			if (re && re.ok) this.getCounselList();
		},
		getItem() {
			const seq = this.loadSeq;
			this.$apiGET('/admin/api/user/admin/detail?cid=' + this.id).then(data => {
				if (seq !== this.loadSeq) return; // 앞 고객의 늦은 응답
				// 본문만 실패하면(500·네트워크) 빈 화면 대신 다시 시도·이전·다음이 있는 안내로 보낸다.
				if (!data || typeof data !== 'object') {
					this.item = null;
					this.denied = 'error';
					return;
				}
				this.item = data;
				// DB: 새로 받은 카드는 다시 가려져 온다. 그 전에 연 상태(contactView)를 남기면 가린 번호에 돋보기가 없어진다.
				this.contactView = false;
				this.revealReq = false;

				this.addInfo.mgrUid = data.mgr_mem_uid;
				this.addInfo.mgrLevel = data.mgr_level;
				this.addInfo.clientType = data.client_type;
				this.addInfo.clientName = data.name;

				this.addInfo.clientMobile1 = data.mobile;
				this.addInfo.clientMobile2 = data.mobile2;

				this.addInfo.clientMobileMemo1 = data.mobile_memo;
				this.addInfo.clientMobileMemo2 = data.mobile2_memo;

				this.addInfo.clientEmail = data.email;
				this.addInfo.clientMemo = data.memo;

				this.addInfo.findMoneyS = data.find_money_s;
				this.addInfo.findMoneyE = data.find_money_e;
				this.addInfo.havingMoney = data.having_money;
				this.addInfo.findArea = data.find_area;
			});
		},
		getMemList() {
			// 게스트는 직원 명단(/setting/etc/mem) 접근권한이 없고 담당자=본인 고정이라 호출 생략.
			if (this.isPartnerGuest) return;
			this.$apiGET('/admin/api/setting/etc/mem').then(data => {
				this.memList = data;
			});
		},
		// ── CS: 매물 검색(매매검색 상세검색과 같은 조건·같은 API) ──
		getBuildingList(pg) {
			this.$apiGET(
				'/admin/api/total?' + 'page=' + (pg - 1) * this.buildingPage.itemSize + sellSearchParams(this.sellOptions),
			).then(data => {
				if (!data || !data.item) return;
				this.buildingList = data.item;
				this.sellLoaded = true;

				this.buildingPage.totalCount = data.pageInfo.totalCount;
				this.buildingPage.page = pg;
				this.buildingPage.pageData = this.$pageDataSetting(
					this.buildingPage.totalCount,
					this.buildingPage.itemSize,
					this.buildingPage.blockSize,
					this.buildingPage.page,
				);
			});
		},
		applySellRecent() {
			const w = this.sellRecentYear ? recentYearWindow() : { s: '', e: '' };
			this.sellRecentWin = this.sellRecentYear ? w : null;
			this.sellOptions_.regDate_S = w.s;
			this.sellOptions_.regDate_E = w.e;
		},
		// 상세검색에서 등록일을 직접 고쳤으면 '최근 1년' 표시를 끈다(둘이 어긋나 보이지 않게). 비교 대상은
		// 오늘의 창이 아니라 마지막으로 채운 창이다. 자정을 넘긴 창에서 날짜를 건드리지 않았는데 꺼지지 않게.
		syncSellRecent(form) {
			const w = this.sellRecentWin;
			this.sellRecentYear = !!w && form.regDate_S === w.s && form.regDate_E === w.e;
			if (!this.sellRecentYear) this.sellRecentWin = null;
		},
		btnSellSearch() {
			// '최근 1년' 이 켜져 있으면 검색할 때마다 오늘 기준으로 창을 다시 채운다.
			if (this.sellRecentYear) this.applySellRecent();
			this.sellOptions = normalizeSellSearch(this.sellOptions_);
			this.sellAppliedRaw = JSON.parse(JSON.stringify(this.sellOptions_));
			this.sellAppliedRecent = this.sellRecentYear;
			this.isSellDetailShow = false;
			this.getBuildingList(1);
		},
		onSellDetailSearch(form) {
			this.sellOptions_ = form;
			this.syncSellRecent(form);
			this.btnSellSearch();
		},
		onSellDetailClose(form) {
			// 검색 없이 닫아도 적은 값은 남는다(매매검색과 같다). 체크 표시도 그 값에 맞춘다.
			this.sellOptions_ = form;
			this.syncSellRecent(form);
			this.isSellDetailShow = false;
		},
		resetSellOptions() {
			this.sellOptions_ = defaultSellSearchOptions();
			this.applySellRecent();
		},
		btnSellReset() {
			this.resetSellOptions();
			this.btnSellSearch();
		},
		btnSellStOption() {
			this.sellOptions_.st_ = this.sellOptions_.st ? SELL_STATUS_ALL.slice() : [];
		},
		onSellRecentYear() {
			this.applySellRecent();
			this.btnSellSearch();
		},
		toggleSellAll(on) {
			const ids = this.buildingList.map(b => b.building_uid);
			if (on) this.addBriefList2 = Array.from(new Set([...this.addBriefList2, ...ids]));
			else this.addBriefList2 = this.addBriefList2.filter(id => !ids.includes(id));
		},
		briefStatusOf(bid) {
			return this.briefStatusMap[bid] || null;
		},
		getCountList(pg) {
			this.$apiGET('/admin/api/user/admin/detail/count?page=' + (pg - 1) * this.countPage.itemSize).then(data => {
				this.countList = data.item;

				this.countPage.totalCount = data.pageInfo.totalCount;
				this.countPage.page = pg;
				this.countPage.pageData = this.$pageDataSetting(
					this.countPage.totalCount,
					this.countPage.itemSize,
					this.countPage.blockSize,
					this.countPage.page,
				);
			});
		},
		getBriefList() {
			const seq = this.loadSeq;
			return this.$apiGET('/admin/api/user/admin/detail/brief?cid=' + this.id).then(data => {
				if (seq !== this.loadSeq) return; // 앞 고객의 늦은 응답(그 브리핑을 완료·삭제하면 앞 고객 것이 바뀐다)
				if (!Array.isArray(data)) return;
				for (let i = 0; i < data.length; i++) {
					data[i].printSt = false;
					data[i].state = false;
					// 완료했던 물건을 다시 대기로 담으면 brief_price(만원)가 남는다. 대기 행의 입력칸은 억 단위라
					// 그대로 두면 '완료 처리' 때 ×10000 이 한 번 더 붙어 INT 범위를 넘는다.
					if (data[i].brief_status !== 'done' && data[i].brief_price != null && data[i].brief_price !== '') {
						data[i].brief_price = Number(data[i].brief_price) / 10000;
					}
				}
				this.briefList = data;
			});
		},
		// reveal: 조회사유를 남기고 연 상태면 서버가 상담·변경내역 속 번호도 원문으로 준다(DB). 기본은 지금 열림 상태.
		getCounselList(reveal) {
			const seq = this.loadSeq;
			const my = ++this.counselSeq;
			this.counselList = [];
			this.chgList = [];
			const rv = (reveal === undefined ? this.revealReq : reveal) ? '&reveal=1' : '';
			this.$apiGET('/admin/api/user/admin/detail/counsel?cid=' + this.id + rv).then(data => {
				// 마지막 요청의 응답만 쓰고 한 번에 바꾼다. 겹친 두 응답을 이어 붙이면 같은 상담이 원문 행과 가린 행으로 두 번 나온다.
				// 원문 요청은 그 사이 열람 상태가 닫혔으면 쓰지 않는다.
				if (seq !== this.loadSeq || my !== this.counselSeq || (rv && !this.revealReq) || !Array.isArray(data)) return;
				const counsel = [];
				const chg = [];
				for (let i = 0; i < data.length; i++) {
					if (data[i].log_type == 'counsel') {
						counsel.push(data[i]);
					} else if (data[i].log_type == 'chg_info') {
						chg.push(data[i]);
					}
				}
				this.counselList = counsel;
				this.chgList = chg;
			});
		},
		getCounselTypeList() {
			this.$apiGET('/admin/api/user/admin/detail/counsel/type').then(data => {
				this.counselTypeList = data;

				if (this.counselTypeList.length) {
					this.counselInfo.id = this.counselTypeList[0].ind_cfg_uid;
				}
			});
		},
		async btnAddBrief() {
			// J-2/Bug S: 다수 row sequentially 저장 — 한 행이라도 실패하면 즉시 중단,
			// '저장 완료' alert 차단. $apiPOST 가 SP+sqlMessage alert.
			for (let i = 0; i < this.addBriefList.length; i++) {
				const re = await this.$apiPOST('/admin/api/user/admin/detail/brief/add', {
					cid: this.id,
					bid: this.addBriefList[i],
				});
				if (re !== true) return;
			}
			this.addBriefList = [];
			this.getBriefList();
			alert('저장이 완료되었습니다.');
		},
		async btnAddBrief2() {
			if (!this.addBriefList2.length) {
				alert('브리핑대기로 넣을 매물을 1개 이상 선택하세요.');
				return;
			}
			this.busy = true;
			try {
				const saved = [];
				for (let i = 0; i < this.addBriefList2.length; i++) {
					const re = await this.$apiPOST('/admin/api/user/admin/detail/brief/add', {
						cid: this.id,
						bid: this.addBriefList2[i],
					});
					if (re !== true) {
						// 앞에서 저장된 것은 선택에서 빼고 표를 다시 받는다(아무것도 안 들어간 것처럼 보이지 않게).
						this.addBriefList2 = this.addBriefList2.filter(b => !saved.includes(b));
						this.getBriefList();
						return;
					}
					saved.push(this.addBriefList2[i]);
				}
				const n = this.addBriefList2.length;
				this.addBriefList2 = [];
				this.briefMode = 'ready';
				this.getBriefList();
				alert(n + '건을 이 고객의 브리핑대기 물건으로 저장했습니다.');
			} finally {
				this.busy = false;
			}
		},
		btnSaveBrief(item) {
			if (this.busy) return;
			this.busy = true;
			const lid = item.client_building_link_uid;
			this.$apiPOST('/admin/api/user/admin/detail/brief/done', {
				lid,
				price: item.brief_price * 10000,
			})
				.then(async re => {
					if (re !== true) return;
					await this.getBriefList();
					// 완료 일시는 서버가 남긴 값을 그대로 보여 준다(화면 시계와 어긋나지 않게).
					const done = this.briefList.find(b => b.client_building_link_uid === lid);
					alert('브리핑완료로 처리했습니다.' + (done && done.brief_done_at ? '\n브리핑 완료 ' + done.brief_done_at : ''));
				})
				.finally(() => {
					this.busy = false;
				});
		},
		btnDeleteBrief(id) {
			if (!confirm('정말로 삭제하시겠습니까?')) {
				return;
			}

			this.$apiPOST('/admin/api/user/admin/detail/brief/delete', {
				lid: id,
			}).then(re => {
				if (re !== true) return;
				this.getBriefList();
			});
		},
		// CZ: 통화로 분류된 상담 유형이면 '부재' 선택을 보인다. 고르지 않으면 통화완료로 저장된다.
		isCallCounsel() {
			const t = this.counselTypeList.find(c => c.ind_cfg_uid == this.counselInfo.id);
			return !!(t && t.is_call);
		},
		btnSaveCounsel() {
			this.$apiPOST('/admin/api/user/admin/detail/counsel/add', {
				cid: this.id,
				subId: this.counselInfo.id,
				memo: this.counselInfo.data,
				callResult: this.isCallCounsel() && this.counselInfo.missed ? 'missed' : 'done',
			}).then(re => {
				if (re !== true) return;
				this.counselInfo.data = '';
				this.counselInfo.missed = false;
				this.getCounselList();
				// 새 상담이력은 자동보류 기준일을 오늘로 당긴다(D-day 를 설정 일수로 다시 계산).
				this.getState();
			});
		},
		btnUserUpdate() {
			this.addInfo.cid = this.id;

			this.$apiPOST('/admin/api/user/admin/detail/counsel/update', this.addInfo).then(data => {
				// J-2/Bug S: $apiPOST 가 5xx/4xx/401 시 false/undefined 를 반환하므로
				// data.error 체크 전에 falsy 가드 필요. 게이트 없이 else 진입 시
				// getItem/팝업닫기/'저장 완료' alert 가 실행되어 실패를 성공으로 인식.
				// LeaseUserDetail.vue btnUserUpdate 와 동일 패턴.
				if (!data) {
					return;
				} else if (data.error) {
					const err = data.info;

					alert(
						'[' +
							this.$CLIENT_TYPE[err.client_type] +
							']\n[' +
							err.mgr_mem_name +
							'] 의 [' +
							err.name +
							'] 고객으로 이미 등록 되어있습니다.',
					);
				} else {
					this.isRegisterPopupShow = false;
					alert('저장이 완료되었습니다.');
					this.refreshAfterSave();
				}
			});
		},
		// 저장 뒤에는 늘 상태부터 다시 묻는다. 담당자를 넘기거나, 미관리 열람(직급 'Y')으로 연 고객을 관리로 바꾸면
		// 이 카드가 내 범위 밖이 된다. 그때 본문·상담·상태를 한꺼번에 부르면 403 안내가 세 번 뜨고 빈 화면이 남았다.
		async refreshAfterSave() {
			const seq = ++this.loadSeq;
			// 열림 표시(contactView)는 새 카드를 받을 때 getItem 이 닫는다. 여기서 먼저 닫으면 다시 읽는 동안 원문 옆에 돋보기가 뜬다.
			// 요청용 열람 상태는 지금 닫는다. 다시 읽는 사이 핀 변경·상담 저장이 상태·상담을 다시 물으면 가린 값을 받아야 한다.
			this.revealReq = false;
			this.isContactPopupShow = false;
			this.contactBusy = false;
			const ok = await this.getState(false);
			if (seq !== this.loadSeq) return;
			if (ok !== true) {
				this.item = null;
				this.isExemptShow = false;
				this.denied = ok || 'error';
				return;
			}
			this.getItem();
			this.getCounselList(false);
		},
		btnUserDelete() {
			if (!confirm('정말로 삭제하시겠습니까?\n삭제된 데이터는 복구할 수 없습니다.')) {
				return;
			}
			this.$apiPOST('/admin/api/user/admin/delete', { cid: this.id }).then(re => {
				// J-2/Bug Q-2: backend success → true / fail → 5xx (resolves false) /
				// 401 → 로그인 redirect (resolves undefined). 실패 시 창을 닫으면
				// $apiPOST 가 띄운 SP+sqlMessage alert 가 사라져 사용자 컨텍스트 손실.
				if (re !== true) return;
				window.open('', '_self').close();
			});
		},
		setPrintAllSt() {
			for (let i = 0; i < this.briefList.length; i++) {
				this.briefList[i].printSt = this.printSt;
			}
		},
		btnOnPrint() {
			let w = window.screen.availWidth;
			let h = window.screen.availHeight;

			let attr = 'width=' + w + ', height=' + h + ', resizable=no, status=no';

			let printIdList = [];

			for (let i = 0; i < this.briefList.length; i++) {
				if (this.briefList[i].printSt) {
					printIdList.push(this.briefList[i].building_uid);
				}
			}

			if (printIdList.length === 0) {
				alert('출력할 매물을 선택하세요.');
				return;
			}

			if (!confirm(printIdList.length + '개 매물을 연쇄출력합니다. 계속하시겠습니까?')) return;

			window.open('/PrintPage2?bid=' + printIdList, '', attr);
		},
		// 목록 화면과 같은 조건(정렬·개인 탭 포함). 목록의 listQuery() 가 실어 보낸 값을 그대로 돌려 쓴다.
		navQuery() {
			const q = this.searchInfoData || {};
			const v = k => (q[k] == null ? '' : q[k]);
			return (
				'clientType=' + v('clientType') +
				'&clientName=' + v('clientName') +
				'&clientMobile=' + v('clientMobile') +
				'&clientMoneyS=' + v('clientMoneyS') +
				'&clientMoneyE=' + v('clientMoneyE') +
				'&clientLevel=' + v('clientLevel') +
				'&mId=' + v('mId') +
				'&sort=' + v('sort') +
				'&tabUid=' + v('tabUid')
			);
		},
		// 이전·다음은 창을 연 순간의 목록 순서를 따라간다. 누를 때마다 'N번째' 를 다시 물으면, 이 창에서 상담을
		// 쓰거나 핀·탭을 바꿔 순서가 움직였을 때 한 명을 건너뛴다(자동보류 임박순에서 상담을 쓰면 그 고객이
		// D-30 자리로 옮겨 가 '다음' 이 매번 한 명씩 빠졌다). 탭에서 빼 목록이 줄어도 빈 고객으로 가지 않는다.
		loadNavIds() {
			const q = this.searchInfoData;
			if (!q || q.idx == null || q.idx === '') return;
			this.$apiGET('/admin/api/user/admin/count/idList?' + this.navQuery()).then(ids => {
				if (!Array.isArray(ids) || !ids.length) return;
				this.navIds = ids.map(Number);
				const at = this.navIds.indexOf(Number(this.id));
				if (at >= 0) this.searchInfoData.idx = at + 1;
				this.searchInfoData.totalCount = this.navIds.length;
			});
		},
		goClient(cid) {
			// 앞 고객 카드에서 골라 둔 매물이 다음 고객의 브리핑대기로 들어가지 않게 선택을 비운다.
			this.addBriefList = [];
			this.addBriefList2 = [];
			this.id = cid;
			this.init();
			this.$router.push({ path: '/UserDetail/' + this.id, query: this.searchInfoData });
		},
		getTotal(act_type) {
			const before = this.searchInfoData.idx;
			switch (act_type) {
				case 'first': //  맨처음      : idx = 1로 변경한다.
					if (this.searchInfoData.idx == 1) {
						alert('처음입니다.');
						return;
					}
					this.searchInfoData.idx = 1;
					break;
				case 'prev': //  이전        : 현재 idx = idx - 1 로 변경한다.
					if (this.searchInfoData.idx == 1) {
						alert('처음입니다.');
						return;
					}
					this.searchInfoData.idx--;
					break;
				case 'next': //  다음        : 현재 idx = idx + 1 로 변경한다.
					if (this.searchInfoData.idx == this.searchInfoData.totalCount) {
						alert('마지막입니다.');
						return;
					}
					this.searchInfoData.idx++;
					break;
				case 'last': //  마지막      : 현재 idx = 마지막으로 변경한다.
					if (this.searchInfoData.idx == this.searchInfoData.totalCount) {
						alert('마지막입니다.');
						return;
					}
					this.searchInfoData.idx = this.searchInfoData.totalCount;
					break;
			}

			if (this.navIds) {
				const cid = this.navIds[Number(this.searchInfoData.idx) - 1];
				if (cid == null) {
					this.searchInfoData.idx = before;
					alert('1부터 ' + this.navIds.length + '까지의 순번을 입력하세요.');
					return;
				}
				this.goClient(cid);
				return;
			}

			this.$apiGET('/admin/api/user/admin/count?' + this.navQuery() + '&page=' + (this.searchInfoData.idx - 1)).then(data => {
				if (!data || !data.client_uid) {
					this.searchInfoData.idx = before;
					alert('목록이 바뀌어 그 순번의 고객이 없습니다. 목록을 새로 열어 주세요.');
					return;
				}
				this.goClient(data.client_uid);
			});
		},
		btnOnDetail(cid, idx, mode) {
			let w = window.screen.availWidth;
			let h = window.screen.availHeight;

			let attr = 'width=' + w + ', height=' + h + ', resizable=no, status=no';

			if (mode == 'total') {
				// 매매검색과 같은 방식: 검색 결과 전체 ID 를 받아 두고 상세 화면이 그 안에서 이전·다음으로 움직인다.
				this.$apiGET('/admin/api/total/count?' + 'page=' + 1 + sellSearchParams(this.sellOptions)).then(data => {
					if (!Array.isArray(data)) return;
					const idList = data.map(d => d.building_uid);
					const pageCnt = this.$store.state.pageCnt++;
					this.$store.dispatch('callSetPage', { idx: pageCnt, idList: idList });

					window.open(
						'/MapDetail/' +
							cid +
							'?pageIdx=' +
							pageCnt +
							'&idx=' +
							(idx + 1 + (this.buildingPage.page - 1) * this.buildingPage.itemSize) +
							'&totalCount=' +
							this.buildingPage.totalCount +
							'&mode=' +
							mode,
						'',
						attr,
					);
				});
			} else if (mode == 'user_count') {
				window.open(
					'/MapDetail/' +
						cid +
						'?idx=' +
						(idx + 1 + (this.countPage.page - 1) * this.countPage.itemSize) +
						'&totalCount=' +
						this.countPage.totalCount +
						'&mode=' +
						mode,
					'',
					attr,
				);
			} else if (mode == 'brief') {
				let idList = [];
				let idx_ = 0;
				for (let i = 0; i < this.briefList.length; i++) {
					if (this.briefList[i].brief_status == this.briefMode) {
						idList.push(this.briefList[i].building_uid);
					}
				}

				for (let i = 0; i < idList.length; i++) {
					if (idList[i] == cid) {
						idx_ = i;
						break;
					}
				}

				window.open(
					'/MapDetail/' +
						cid +
						'?idx=' +
						(idx_ + 1) +
						'&totalCount=' +
						idList.length +
						'&idList=' +
						idList +
						'&mode=' +
						'count',
					'',
					attr,
				);
			}

			// console.log(openWin);
		},
	},
};
</script>

<style lang="scss">
// 값의 출처는 DESIGN.md 하나뿐이다. 색·간격을 숫자로 새로 만들지 않는다.
@import '@/assets/css/design-tokens.scss';

.detail-page--con .con .tit .btn.ud-pin {
	font-size: 12px;
	color: $dt-color-ink-faint;
	&.on {
		color: $dt-color-primary-ink;
		font-weight: 600;
	}
}
// 아래 span 들은 표 칸(td) 바로 안에 있다. bootstrap 의 `.table>:not(caption)>*>*` 셀 규칙(0,1,1)이
// tbody 없는 Vue 표에서 td 의 자식 span 에 8px 패딩을 입히므로 .detail-page 를 앞에 붙여(0,2,0) 이긴다.
// 자동보류 D-day (UserAdmin 목록과 같은 규칙: 빨강 = 초과·임박, 주황 잉크 = 주의)
.detail-page .ud-dday {
	display: inline-block;
	padding: 0 6px;
	font-size: 12px;
	line-height: 18px;
	border: 1px solid transparent;
	border-radius: $dt-rounded-chip;
	&.is-soon {
		color: $dt-color-warning-ink;
		border-color: $dt-color-warning;
		font-weight: 600;
	}
	&.is-urgent,
	&.is-over {
		color: $dt-color-danger;
		border-color: $dt-color-danger;
		font-weight: 600;
	}
	&.is-exempt {
		color: $dt-color-ink-muted;
		border-color: $dt-color-line-strong;
	}
	&--sub {
		margin-left: 4px;
		font-size: 11px;
		color: $dt-color-ink-faint;
	}
}
.ud-contact-note {
	margin: 4px 0 0;
	font-size: 12px;
	color: $dt-color-ink-faint;
}
.detail-page .ud-hold-note {
	margin-left: 6px;
	font-size: 12px;
	color: $dt-color-ink-faint;
}
.detail-page .ud-hold-btns {
	margin-left: 8px;
	.btn + .btn {
		margin-left: 4px;
	}
}
// 내 탭 칩: 2차 필터 칩과 같은 모양(DESIGN.md filter-chip).
.detail-page--con .con .table .btn.ud-tab {
	height: 22px;
	padding: 0 9px;
	margin: 2px 4px 2px 0;
	font-size: 12px;
	line-height: 1;
	border: 1px solid $dt-color-line-strong;
	border-radius: $dt-rounded-full;
	background: $dt-color-canvas;
	color: $dt-color-ink-muted;
	float: none;
	&.on {
		background: $dt-color-primary-ink;
		border-color: $dt-color-primary-ink;
		color: #fff;
	}
	&.ud-tab--add {
		background: $dt-color-surface;
		color: $dt-color-primary-ink;
	}
}
// 상담 답글(대댓글): 원 상담 바로 아래, 한 단 들여 쓴 행.
.ud-counsel {
	.btn.ud-reply-btn {
		padding: 0 4px;
		border: 0;
		font-size: 12px;
		color: $dt-color-primary-ink;
	}
	.ud-reply td {
		background: $dt-color-surface-sunken;
		font-size: 12px;
		color: $dt-color-ink-muted;
	}
	.ud-reply--date {
		white-space: nowrap;
		text-align: left;
	}
	.ud-reply--input .form-control {
		width: 100%;
	}
}
.ud-brief-hint {
	font-size: 12px;
	color: $dt-color-ink-faint;
	text-align: left;
}
.ud-brief-act {
	white-space: nowrap;
	.btn + .btn {
		margin-left: 4px;
	}
}
.detail-page .ud-done-at {
	white-space: nowrap;
	&--who {
		display: block;
		font-size: 11px;
		color: $dt-color-ink-faint;
	}
}
.ud-search {
	.input-top {
		flex-wrap: wrap;
		row-gap: 6px;
		.form-control {
			flex: 1;
			min-width: 160px;
		}
		.btn {
			margin-left: 6px;
		}
	}
	&--cnt {
		margin-left: auto;
		font-size: 12px;
		color: $dt-color-ink-muted;
		align-self: center;
	}
	&--tags {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 4px;
		margin-bottom: 8px;
	}
	.btn.ud-search--reset {
		padding: 0 6px;
		border: 0;
		font-size: 12px;
		color: $dt-color-primary-ink;
	}
}
.detail-page .ud-chip {
	display: inline-block;
	margin-left: 2px;
	padding: 0 5px;
	font-size: 11px;
	line-height: 16px;
	color: $dt-color-ink-muted;
	border: 1px solid $dt-color-line-strong;
	border-radius: $dt-rounded-chip;
	white-space: nowrap;
}
.ud-help {
	font-size: 12px;
	line-height: 1.6;
	color: $dt-color-ink-faint;
	margin-bottom: 10px;
}
.ud-denied {
	padding: 40px 0 16px;
	text-align: center;
	font-size: 14px;
	color: $dt-color-ink-muted;
}
.ud-denied-actions {
	display: flex;
	justify-content: center;
	gap: 6px;
	padding-bottom: 40px;
}
</style>
